import UserProfile from "../app/shared/UserProfile";
import config from "../config/environment.js";

const { url, realm, clientId } = config.keycloak;
const TOKEN_URL = `${url}/realms/${realm}/protocol/openid-connect/token`;

let _refreshTimer = null;

const _parseToken = (token) => {
  const parsed = JSON.parse(atob(token.split(".")[1]));
  const resource = parsed.resource_access?.[clientId];
  return {
    user: parsed.preferred_username,
    name: parsed.name,
    email: parsed.email,
    roles: resource?.roles ?? null,
    province: parsed.province ?? null,
    logout: doLogout,
  };
};

const _scheduleRefresh = (expiresInSec) => {
  if (_refreshTimer) clearTimeout(_refreshTimer);
  const delay = Math.max((expiresInSec - 60) * 1000, 10_000);
  _refreshTimer = setTimeout(_refreshToken, delay);
};

const _storeSession = (data) => {
  sessionStorage.setItem("auth_token", data.access_token);
  sessionStorage.setItem("auth_refresh_token", data.refresh_token);
  sessionStorage.setItem("auth_expires_at", Date.now() + data.expires_in * 1000);
  UserProfile.getInstance().setToken(data.access_token);
  UserProfile.getInstance().setUserInfo(_parseToken(data.access_token));
  _scheduleRefresh(data.expires_in);
};

const _refreshToken = async () => {
  const refresh = sessionStorage.getItem("auth_refresh_token");
  if (!refresh) {
    doLogout();
    return;
  }
  try {
    const body = new URLSearchParams({
      grant_type: "refresh_token",
      client_id: clientId,
      refresh_token: refresh,
    });
    const res = await fetch(TOKEN_URL, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    });
    if (!res.ok) throw new Error("Refresh failed");
    _storeSession(await res.json());
  } catch {
    doLogout();
  }
};

const checkSession = () => {
  const token = sessionStorage.getItem("auth_token");
  const expiresAt = sessionStorage.getItem("auth_expires_at");
  if (!token || !expiresAt || Date.now() >= Number(expiresAt)) return false;
  UserProfile.getInstance().setToken(token);
  UserProfile.getInstance().setUserInfo(_parseToken(token));
  const remainingSec = Math.floor((Number(expiresAt) - Date.now()) / 1000);
  _scheduleRefresh(remainingSec);
  return true;
};

const login = async (username, password) => {
  const body = new URLSearchParams({
    grant_type: "password",
    client_id: clientId,
    username,
    password,
  });
  const res = await fetch(TOKEN_URL, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body,
  });
  if (!res.ok) {
    throw new Error("Usuario o contraseña incorrectos");
  }
  _storeSession(await res.json());
};

const doLogout = () => {
  if (_refreshTimer) clearTimeout(_refreshTimer);
  sessionStorage.removeItem("auth_token");
  sessionStorage.removeItem("auth_refresh_token");
  sessionStorage.removeItem("auth_expires_at");
  UserProfile.getInstance().setToken("");
  UserProfile.getInstance().setUserInfo(null);
  const base = config.paths.base || "/controlsube/";
  window.location.href = window.location.origin + base;
};

const getToken = () => sessionStorage.getItem("auth_token");

const UserService = {
  checkSession,
  login,
  doLogout,
  getToken,
};

export default UserService;
